import { ref as n } from "vue";
function u(e) {
  return [e.screenX, e.screenY];
}
function l() {
  let e = n([-1, -1]);
  return { wasMoved(r) {
    let t = u(r);
    return e.value[0] === t[0] && e.value[1] === t[1] ? !1 : (e.value = t, !0);
  }, update(r) {
    e.value = u(r);
  } };
}
export {
  l as useTrackedPointer
};
